import React, { Component } from 'react';
import { node } from 'prop-types';
import { Provider } from './HeaderContext';

export default class HeaderProvider extends Component {
    static propTypes = {
        children: node.isRequired,
    };

    setSearchTitle = query => {
        let title;
        if (query) {
            title = `Votre recherche pour '${query}'`;
            document.querySelector(
                'meta[name="description"]',
            ).content = `ManoMano : tous vos produits ${query} au meilleur prix`;
        } else {
            title =
                'ManoMano : Achat en ligne bricolage, rénovation et jardinage';
        }
        document.title = title;
        const metaPropertyOGTitle = document.querySelector(
            'meta[property="og:title"]',
        );
        if (metaPropertyOGTitle && metaPropertyOGTitle.content) {
            metaPropertyOGTitle.content = title;
        }
    };

    render() {
        const { children } = this.props;
        return (
            <Provider
                value={{
                    actions: {
                        setSearchTitle: this.setSearchTitle,
                    },
                }}
            >
                {children}
            </Provider>
        );
    }
}
